export default __webpack_public_path__ + "static/media/11.656578d7.mp3";